/**
 * validate email
 * @param email
 * @returns {boolean}
 */
export function validateEmail(email) {
  const reg = /^[A-Za-z0-9]+([-_.][A-Za-z0-9]+)*@([A-Za-z0-9]+[-.])+[A-Za-z0-9]{2,}$/
  return reg.test(email)
}

/**
 * 校验手机 纯数字，6-20位
 * @param str
 * @returns {boolean}
 */
export function validatePhone(str) {
  const reg = /^\d{6,20}$/
  return reg.test(str)
}

/**
 * 校验验证码 纯数字，6位
 * @param str
 * @returns {boolean}
 */
export function validateCode(str) {
  const reg = /^\d{6}$/
  return reg.test(str)
}

/**
 * 校验验证码 数字+字母，6位
 * @param varifyCode
 * @returns {boolean}
 */
export function validateVarifyCode(str) {
  const reg = /^[A-Za-z0-9]{6}$/
  return reg.test(str)
}
